import { ApplicationRef, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { enableDebugTools, platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production || environment.staging) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
.then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
.catch(err => console.log(err));
